import type { Cliente } from '../db/tipos'

// Endereco de ENTREGA (migration 0036, pedido dela 11/10). Nao ha coluna
// "idem": os cinco campos vazios SAO o idem -- e assim que os clientes
// antigos ja chegam. Escolher "Idem" na ficha apaga os cinco.
export const CAMPOS_ENTREGA = [
  'entrega_endereco', 'entrega_bairro', 'entrega_municipio', 'entrega_uf', 'entrega_cep',
] as const
export type CampoEntrega = (typeof CAMPOS_ENTREGA)[number]
type ComEntrega = Partial<Pick<Cliente, CampoEntrega>>

export const ENTREGA_VAZIA: Record<CampoEntrega, null> = {
  entrega_endereco: null, entrega_bairro: null, entrega_municipio: null, entrega_uf: null, entrega_cep: null,
}

export function temEntregaPropria(c: ComEntrega): boolean {
  return CAMPOS_ENTREGA.some((k) => (c[k] ?? '').trim() !== '')
}

// Mesmo molde "junta o que existe, com virgula" do endereco do cliente no PDF.
export function textoEnderecoEntrega(c: ComEntrega): string | null {
  if (!temEntregaPropria(c)) return null
  return [
    c.entrega_endereco, c.entrega_bairro, c.entrega_municipio, c.entrega_uf,
    c.entrega_cep?.trim() ? `CEP ${c.entrega_cep.trim()}` : null,
  ]
    .map((v) => v?.trim())
    .filter(Boolean)
    .join(', ')
}
